// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

export function MpesaPageContent(): Node {

  return(
    <Root data-test-id="page-pending-payment">
      Please, login to the M-PESA app and complete your purchase :)
    </Root>
  );
}

const Root = styled.div`
  padding: 32px 16px;
  font-size: 1.8em;
  font-family: ${props => props.theme.fontFamily.display};
`;
